export default "__VITE_ASSET__5496ea0a__"